import { Injectable } from '@angular/core';
import { OrderType } from '@cureskin/api-client/src/server-api';
import { AppConfig } from 'client/app/app.config';
import { Entity } from '@cureskin/api-client-rn';

@Injectable({
  providedIn: 'root',
})

export class OrderHelper {
  constructor(
    private readonly appConfig: AppConfig,
  ) {}

  filterOrdersByType(orders: Array<Entity['Order']>, type: string): Array<Entity['Order']> {
    if (!orders) {
      return [];
    }
    return orders.filter((order: Entity['Order']): boolean => order?.type === type);
  }

  isOrderTypeRegimen(orderType: OrderType): boolean {
    return orderType === this.appConfig.Shared.Order.Type.REGIMEN;
  }

  sortOrdersByDeliveredOn(orders: Array<Entity['Order']>, ascending: boolean = false): Array<Entity['Order']> {
    if (!orders) {
      return [];
    }

    return orders.sort((a, b) => {
      const dateA = new Date(a?.deliveredOn).getTime();
      const dateB = new Date(b?.deliveredOn).getTime();
      return ascending ? dateA - dateB : dateB - dateA;
    });
  }
}
